var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7h14M9.143 7.2V5.6c0-.424.15-.831.418-1.131.268-.3.632-.469 1.01-.469h2.858c.378 0 .742.169 1.01.469.268.3.418.707.418 1.131v1.6M17 7.2v11.2c0 .424-.15.831-.418 1.131-.268.3-.632.469-1.01.469H8.428c-.38 0-.743-.169-1.01-.469A1.703 1.703 0 017 18.4V7.2h10zM10 11v5M14 11v5",
    stroke: "#A7A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTrashBin;